import axiosInstance from "../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const companyDetail = createAsyncThunk(
  "profile/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/developer-tool/fetch_current_user`, { authRequired: true });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const companyDetailReducer = createSlice({
  name: "companydetail",
  initialState: {
    companyDetails: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(companyDetail.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(companyDetail.fulfilled, (state, action) => {
        state.companyDetails = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(companyDetail.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default companyDetailReducer.reducer;
